import { useEffect } from 'react'

/*
 * Publishes the vertical scrollbar's width as `--hx-scrollbar` on the page root.
 *
 * The full-bleed sections escape WordPress's content column with `vw` units, and `vw`
 * counts the scrollbar while the content box does not. Without this correction every bleed
 * section overhangs the viewport by a scrollbar width and the whole page scrolls sideways.
 */
const measure = () => {
	const scrollbar = window.innerWidth - document.documentElement.clientWidth
	document.documentElement.style.setProperty('--hx-scrollbar', `${Math.max(0, scrollbar)}px`)
}

const useViewportBleed = () => {
	useEffect(() => {
		measure()
		window.addEventListener('resize', measure)
		return () => window.removeEventListener('resize', measure)
	}, [])
}

export default useViewportBleed
